import { _ as _objectSpread2, b as _slicedToArray, c as _objectWithoutProperties } from './transitions-eb14ab1a.esm.js';
import { calc } from '@chakra-ui/theme-tools';
import { headingPresets, headingSizes, textSizes } from '@hover/blueprint-theme';
import { fromEntries, entries } from '@hover/utilities';

var _excluded = ["lineHeight", "fontSize"];
var defineTextStyles = function defineTextStyles(text, heading) {
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fromEntries(entries(text).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      size = _ref2[0],
      value = _ref2[1];
    return ["body".concat(size), value];
  }))), fromEntries(entries(heading).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      size = _ref4[0],
      value = _ref4[1];
    return ["heading".concat(size), value];
  }))), fromEntries(entries(heading).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      size = _ref6[0],
      value = _ref6[1];
    return ["heading".concat(size, "WithMargin"), _objectSpread2(_objectSpread2({}, value), {}, {
      marginBottom: headingPresets[size].marginBottom
    })];
  }))), fromEntries(entries(text).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      size = _ref8[0],
      _ref8$ = _ref8[1];
      _ref8$.lineHeight;
      var fontSize = _ref8$.fontSize,
      rest = _objectWithoutProperties(_ref8$, _excluded);
    return ["code".concat(size), _objectSpread2(_objectSpread2({}, rest), {}, {
      fontSize: calc.subtract(fontSize, '1px')
    })];
  })));
};
var textStyles = /*#__PURE__*/defineTextStyles(textSizes, headingSizes);

export { defineTextStyles as d, textStyles as t };
